module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Team")])], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "teamTab",
    attrs: {
      "type": "card",
      "active-name": _vm.activeTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "members",
      "label": _vm.attrText.member
    }
  }, [_c('div', {
    staticClass: "ssk-wrapper"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowTeamAddMember()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('translate', [_vm._v("Add Member")])], 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Batch Import")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-select', {
    staticClass: "condition-search",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.initInput
    },
    model: {
      value: (_vm.search.user),
      callback: function($$v) {
        _vm.search.user = $$v
      },
      expression: "search.user"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.account,
      "value": "q_account"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "icon": "search",
      "disabled": _vm.search.user === '',
      "on-icon-click": _vm.onSearchMemberClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearchMemberClick($event)
      }
    },
    model: {
      value: (_vm.search.val),
      callback: function($$v) {
        _vm.search.val = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "search.val"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.team.list,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.displayNickname,
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.type,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [(scope.row.is_admin == 0) ? _c('p', [_vm._v(_vm._s(_vm.attrText.ordinary))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 1) ? _c('p', [_vm._v(_vm._s(_vm.attrText.admin))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 2) ? _c('p', [_vm._v(_vm._s(_vm.attrText.auditAdmin))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 3) ? _c('p', [_vm._v(_vm._s(_vm.attrText.optAdmin))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 4) ? _c('p', [_vm._v(_vm._s(_vm.attrText.safeAdmin))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status) ? _c('p', {
          style: ({
            color: '#F56C6C'
          })
        }, [_vm._v("禁用")]) : _c('p', {
          style: ({
            color: '#67C23A'
          })
        }, [_vm._v("启用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingTeamAccountWorkgroup',
              params: {
                id: scope.row.id
              },
              query: {
                type: 'workgroup',
                accountName: scope.row.name
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('translate', [_vm._v("Project")])], 1)], 1), _vm._v(" "), (_vm.account.is_admin == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.resetMFA(scope.row, scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Reset MFA")])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowTeamMemberSetting(scope.row, scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.id === _vm.$store.getters.account.id || scope.row.is_admin === 1 || _vm.$store.getters.account.is_admin != 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.changeStatus(scope.row, scope.$index)
            }
          }
        }, [(scope.row.status) ? _c('translate', [_vm._v("Enable")]) : _c('translate', [_vm._v("Disable")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting,
            "disabled": scope.row.id === _vm.$store.getters.account.id || scope.row.is_admin === 1 || _vm.$store.getters.account.is_admin != 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.deleteMember(scope.row)
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.team.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.team.totalPage,
      "page-size": 10,
      "current-page": _vm.team.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.team.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "group",
      "label": _vm.attrText.group
    }
  }, [_c('div', {
    staticClass: "ssk-wrapper"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowTeamAddGroup()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('translate', [_vm._v("Create Group")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.attrText.groupInputName
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearchGroupClick()
      }
    },
    model: {
      value: (_vm.searchGroup.val),
      callback: function($$v) {
        _vm.searchGroup.val = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchGroup.val"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": _vm.onSearchGroupClick
    }
  }, [_c('translate', [_vm._v("Search")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.group.list,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingTeamGroupDetail',
              params: {
                id: scope.row.id
              },
              query: {
                name: scope.row.name
              }
            }
          }
        }, [_c('a', {
          staticClass: "el-button--text"
        }, [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.comment,
      "prop": "note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.note ? scope.row.note : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.membersNumber,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [_c('p', [_vm._v(_vm._s(scope.row.member_count || 0))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingTeamGroupWorkgroup',
              params: {
                id: scope.row.id
              },
              query: {
                type: 'workgroup',
                groupName: scope.row.name
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('translate', [_vm._v("Project")])], 1)], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowTeamGroupSetting(scope.row, scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.deleteGroup(scope.row, scope.row.member_count)
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.group.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.group.totalPage,
      "page-size": 10,
      "current-page": _vm.group.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.group.currentPage = $event
      },
      "current-change": _vm.onChangeGroupPage
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "team-set",
    attrs: {
      "name": "settings",
      "label": _vm.attrText.Setting
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "teamSetForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.settingForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.code
    }
  }, [_vm._v(_vm._s(_vm.settingForm.domain))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.teamName,
      "prop": "fullName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.settingForm.fullName),
      callback: function($$v) {
        _vm.settingForm.fullName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingForm.fullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.person,
      "prop": "contactName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.settingForm.contactName),
      callback: function($$v) {
        _vm.settingForm.contactName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingForm.contactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.phone,
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel"
    },
    model: {
      value: (_vm.settingForm.contactPhone),
      callback: function($$v) {
        _vm.settingForm.contactPhone = $$v
      },
      expression: "settingForm.contactPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.address,
      "prop": "contactAddress"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.settingForm.contactAddress),
      callback: function($$v) {
        _vm.settingForm.contactAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingForm.contactAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ip,
      "prop": "ipWhitelist"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.mutip
    },
    model: {
      value: (_vm.settingForm.ipWhitelist),
      callback: function($$v) {
        _vm.settingForm.ipWhitelist = $$v
      },
      expression: "settingForm.ipWhitelist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.adminIP,
      "prop": "adminWhitelist"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.mutip
    },
    model: {
      value: (_vm.settingForm.adminWhitelist),
      callback: function($$v) {
        _vm.settingForm.adminWhitelist = $$v
      },
      expression: "settingForm.adminWhitelist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.codeIPWhitelist
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.settingForm.codeIpWhitelist),
      callback: function($$v) {
        _vm.settingForm.codeIpWhitelist = $$v
      },
      expression: "settingForm.codeIpWhitelist"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("The creator's IP is added automatically; only whitelisted IPs can connect")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.loginHoldTime,
      "prop": "session_expire_time"
    }
  }, [_c('div', {
    staticClass: "loginHoldTime"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "max": 480,
      "min": 30,
      "placeholder": _vm.attrText.takesLoginAgain
    },
    model: {
      value: (_vm.settingForm.session_expire_time),
      callback: function($$v) {
        _vm.settingForm.session_expire_time = $$v
      },
      expression: "settingForm.session_expire_time"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("minutes")])], 1)]), _vm._v(" "), (_vm.$store.getters.account.unique_id) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.adminUser
    }
  }, [_c('el-select', {
    staticClass: "settingSelect",
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.settingForm.adminUser),
      callback: function($$v) {
        _vm.settingForm.adminUser = $$v
      },
      expression: "settingForm.adminUser"
    }
  }, _vm._l((_vm.adminUserList), function(user, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "height": "50px"
      },
      attrs: {
        "value": user.account,
        "label": user.account
      }
    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.account))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.teamToken
    }
  }, [_c('div', {
    staticClass: "teamToken"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.teamToken,
      "readonly": ""
    },
    model: {
      value: (_vm.settingForm.domain_token),
      callback: function($$v) {
        _vm.settingForm.domain_token = $$v
      },
      expression: "settingForm.domain_token"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.updateTeamToken
    }
  }, [_c('translate', [_vm._v("Update")])], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.bindedWorkSpace
    }
  }, [_c('div', {
    staticClass: "bindedWorkSpace"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请先绑定工作空间",
      "readonly": ""
    },
    model: {
      value: (_vm.settingForm.bindedWorkSpaceName),
      callback: function($$v) {
        _vm.settingForm.bindedWorkSpaceName = $$v
      },
      expression: "settingForm.bindedWorkSpaceName"
    }
  }), _vm._v(" "), (_vm.settingForm.bindedWorkSpaceId) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.unbindWorkSpace
    }
  }, [_c('translate', [_vm._v("Unbind")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.mfa
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.settingForm.iscompanyMfaOpen),
      callback: function($$v) {
        _vm.settingForm.iscompanyMfaOpen = $$v
      },
      expression: "settingForm.iscompanyMfaOpen"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.compelChangePassword
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.settingForm.iscompanyPassword),
      callback: function($$v) {
        _vm.settingForm.iscompanyPassword = $$v
      },
      expression: "settingForm.iscompanyPassword"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Team members request password changes every 90 days")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.loginLockout
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.loginLockout),
      callback: function($$v) {
        _vm.settingForm.loginLockout = $$v
      },
      expression: "settingForm.loginLockout"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("If you enter the password incorrectly 10 times in a row, your account will be locked for 1 hour")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.passwordStrength
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settingForm.passwordStrength),
      callback: function($$v) {
        _vm.settingForm.passwordStrength = $$v
      },
      expression: "settingForm.passwordStrength"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_c('translate', [_vm._v("weak")])], 1), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_c('translate', [_vm._v("medium")])], 1), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_c('translate', [_vm._v("strong")])], 1)], 1), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingForm.passwordStrength === 0),
      expression: "settingForm.passwordStrength === 0"
    }],
    staticStyle: {
      "margin-top": "15px",
      "max-width": "350px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Team member password complexity is not required")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingForm.passwordStrength === 1),
      expression: "settingForm.passwordStrength === 1"
    }],
    staticStyle: {
      "margin-top": "15px",
      "max-width": "350px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("The password must be at least 6 characters long and must contain two types of three:uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingForm.passwordStrength === 2),
      expression: "settingForm.passwordStrength === 2"
    }],
    staticStyle: {
      "margin-top": "15px",
      "max-width": "350px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "set-btn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.settingForm.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSet()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "sso",
    attrs: {
      "name": "sso",
      "label": "SSO"
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "ssoSetForm",
    staticClass: "sso-form",
    attrs: {
      "model": _vm.ssoForm,
      "rules": _vm.ssoRules,
      "label-width": "180px",
      "show-message": false
    }
  }, [_c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.sso
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.ssoForm.is_open),
      callback: function($$v) {
        _vm.ssoForm.is_open = $$v
      },
      expression: "ssoForm.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.is_account_password
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.is_account_password),
      callback: function($$v) {
        _vm.ssoForm.is_account_password = $$v
      },
      expression: "ssoForm.is_account_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.type,
      "prop": "sso_type"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.sso_type),
      callback: function($$v) {
        _vm.ssoForm.sso_type = $$v
      },
      expression: "ssoForm.sso_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "SAML2.0",
      "value": "SAML"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.id_vendor,
      "prop": "id_vendor"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.id_vendor,
      "maxlength": 64,
      "show-word-limit": "",
      "clearable": "",
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.id_vendor),
      callback: function($$v) {
        _vm.ssoForm.id_vendor = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.id_vendor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.WriterMetadataDocument,
      "prop": "fileList"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.uploadAction,
      "drag": "",
      "accept": "text/xml",
      "limit": 1,
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.removeFile,
      "file-list": _vm.ssoForm.fileList,
      "disabled": !_vm.ssoForm.is_open
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" Only the xml file format is supported. The file size should not exceed 5MB and a maximum of 1 file can be uploaded. ")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.login_url,
      "prop": "login_url"
    }
  }, [_c('div', {
    staticClass: "copy-text"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.login_url,
      "disabled": ""
    },
    model: {
      value: (_vm.ssoForm.login_url),
      callback: function($$v) {
        _vm.ssoForm.login_url = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.login_url"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.ssoForm.login_url),
      expression: "ssoForm.login_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-clone fa-sm"
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.assertion_url,
      "prop": "assertion_url"
    }
  }, [_c('div', {
    staticClass: "copy-text"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.assertion_url,
      "disabled": ""
    },
    model: {
      value: (_vm.ssoForm.assertion_url),
      callback: function($$v) {
        _vm.ssoForm.assertion_url = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.assertion_url"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.ssoForm.assertion_url),
      expression: "ssoForm.assertion_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-clone fa-sm"
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.access_white_list,
      "prop": "access_white_list"
    }
  }, [_c('div', {
    staticClass: "copy-text"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 10
      },
      "resize": "none",
      "placeholder": "支持输入多个邮箱域名地址，例如：cloudcare.cn，多个域名用逗号分隔。",
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.access_white_list),
      callback: function($$v) {
        _vm.ssoForm.access_white_list = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.access_white_list"
    }
  }), _vm._v(" "), _c('el-tooltip', [_c('div', {
    slot: "content"
  }, [_c('translate', [_vm._v("Emails with the same domain suffix have the permission to obtain the single sign-on access link for this identity provider. When users log in for the first time, the system will dynamically create a CloudLinker member account, eliminating the need to create it in the system in advance.")]), _c('br'), _c('translate', [_vm._v("The default account permission is: Ordinary Member")])], 1), _vm._v(" "), _c('i', {
    staticClass: "fa fa-question-circle fa-lg"
  })])], 1)]), _vm._v(" "), _c('el-button', {
    staticClass: "set-btn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.ssoForm.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSetSSO()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6319d61f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/team.vue
// module id = 578
// module chunks = 4 5 6